import {
  Button,
  CircularProgress,
  Container,
  Grid,
  TextField,
  Typography,
  Paper,
  Breadcrumbs,
  Modal,
  Box,
} from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { getSweetAlert } from "../helper"; 
import {
  UPDATE_USER_COMMISSION,
  GET_USER_COMMISSION,
} from "../constant/endpoint";

const UserCommissionViewer = () => {
  const [userId, setUserId] = useState("");
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(false);

  const [modalOpen, setModalOpen] = useState(false);
  const [updatedTrade, setUpdatedTrade] = useState("");
  const [updatedSession, setUpdatedSession] = useState("");

  const [updateCashBack, setUpdateCashBack] = useState(0);

  const breadcrumbs = [
    <Link underline="hover" key="1" color="inherit" to={""}>
      <h4>Admin Commsion</h4>
    </Link>,
  ];

  const handleSearch = async () => {
    if (!userId) {
      getSweetAlert("error", "Please enter a User ID");
      return;
    }

    try {
      setLoading(true);
      const response = await axios.get(`${GET_USER_COMMISSION}?id=${userId}`);
      if (response.data.status === "success") {
        setUserData(response.data.data);
      } else {
        setUserData(null);
        getSweetAlert("error", "User not found");
      }
    } catch (error) {
      console.error("Error fetching user commission:", error);
      getSweetAlert("error", "Failed to fetch user commission");
    } finally {
      setLoading(false);
    }
  };

  const handleOpenModal = () => {
    setUpdatedTrade(userData.admin_comm_trade || "");
    setUpdateCashBack(userData.admin_cashback_amount || "");
    setUpdatedSession(userData.admin_comm_trade_session || "");
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleUpdateCommission = async () => {
    // Validate updated trade and session to be >= 0
    if (updatedTrade < 0 || updatedSession < 0) {
      getSweetAlert("error", "Commission values cannot be less than 0");
      return;
    }

    try {
      const payload = {
        admin_comm_trade: updatedTrade,
        admin_comm_trade_session: updatedSession,
        admin_cashback_amount: updateCashBack == "" ? 0 : updateCashBack,
      };

      const response = await axios.post(
        `${UPDATE_USER_COMMISSION}?id=${userId}`,
        payload
      );
      if (response.data.status === "success") {
        getSweetAlert("success", "Commission updated successfully");
        handleSearch();
        handleCloseModal();
      } else {
        getSweetAlert("error", "Failed to update commission");
      }
    } catch (error) {
      console.error("Error updating commission:", error);
      getSweetAlert("error", "Update failed");
    }
  };

  const handleTradeChange = (e) => {
    const value = e.target.value;
    if (value >= 0) {
      setUpdatedTrade(value);
    }
  };

  const handleSessionChange = (e) => {
    const value = e.target.value;
    if (value >= 0) {
      setUpdatedSession(value);
    }
  };
   const handleCashBackChange = (e) => {
    const value = e.target.value;
    if (value >= 0) {
      setUpdateCashBack(value);
    }
  };

  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 9999,
            paddingTop: "20%",
          }}
        >
          <CircularProgress />
        </div>
      )}

      <div className="homeCard">
        <div className="subHomeCard">
          <Container maxWidth="xl" style={{ marginTop: "30px" }}>
            <Breadcrumbs separator="›" style={{ marginBottom: "16px" }}>
              {breadcrumbs}
            </Breadcrumbs>

            <Typography variant="h5" gutterBottom>
              Search
            </Typography>

            <Grid container spacing={2} style={{ maxWidth: 600 }}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  value={userId}
                  onChange={(e) => setUserId(e.target.value)}
                  placeholder="Enter User ID..."
                />
              </Grid>

              <Grid item xs={12} style={{ textAlign: "right" }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSearch}
                  disabled={loading}
                >
                  {loading ? (
                    <CircularProgress size={24} color="inherit" />
                  ) : (
                    "Search"
                  )}
                </Button>
              </Grid>
            </Grid>

            {userData && (
              <Paper
                elevation={3}
                style={{
                  marginTop: "24px",
                  padding: 16,
                }}
              >
                <Typography variant="h6" gutterBottom>
                  Commission Details
                </Typography>

                <TableContainer>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>
                          <strong>User ID</strong>
                        </TableCell>
                        <TableCell>
                          <strong>Admin Commission Trade</strong>
                        </TableCell>
                        <TableCell>
                          <strong>Admin Commission Session</strong>
                        </TableCell>
                         <TableCell>
                          <strong>Admin CashBack Amount</strong>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell>{userData._id}</TableCell>
                        <TableCell>{userData.admin_comm_trade}</TableCell>
                        <TableCell>
                          {userData.admin_comm_trade_session}
                        </TableCell>
                        <TableCell>
                          {userData.admin_cashback_amount}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
            )}

            {userData && (
              <div style={{ textAlign: "right", marginTop: "16px" }}>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={handleOpenModal}
                >
                  Update Commission
                </Button>
              </div>
            )}

            {/* Modal */}
            <Modal open={modalOpen} onClose={handleCloseModal}>
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: 400,
                  bgcolor: "background.paper",
                  boxShadow: 24,
                  p: 4,
                  borderRadius: 2,
                }}
              >
                <Typography variant="h6" gutterBottom>
                  Update Commission
                </Typography>
                <TextField
                  fullWidth
                  label="Admin Commission Trade"
                  type="number"
                  margin="normal"
                  value={updatedTrade}
                  onChange={handleTradeChange}
                />
                <TextField
                  fullWidth
                  label="Admin Commission Session"
                  type="number"
                  margin="normal"
                  value={updatedSession}
                  onChange={handleSessionChange}
                />
                <TextField
                  fullWidth
                  label="Admin CashBack Percentage"
                  type="number"
                  margin="normal"
                  value={updateCashBack}
                  onChange={handleCashBackChange}
                />
                <div style={{ textAlign: "right", marginTop: "16px" }}>
                  <Button onClick={handleCloseModal} style={{ marginRight: 8 }}>
                    Cancel
                  </Button>
                  <Button variant="contained" onClick={handleUpdateCommission}>
                    Update
                  </Button>
                </div>
              </Box>
            </Modal>
          </Container>
        </div>
      </div>
    </>
  );
};

export default UserCommissionViewer;
